import {OrganisationsState} from './OrganisationsState';
import {
  GET_ORGANISATIONS_SUCCESS,
  SharedOrganisationsActionsType,
} from './SharedOrganisationsActions';

const initialState: OrganisationsState = {
  data: null,
};

export const sharedOrganisationsReducer = (
  state: OrganisationsState = initialState,
  action: SharedOrganisationsActionsType,
) => {
  switch (action.type) {
    case GET_ORGANISATIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };

    // case UPDATE_ORGANISATION_SUCCESS:
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       [action.payload.ref]: action.payload,
    //     },
    //   };
    default:
      return state;
  }
};
